<mat-toolbar>
  <div class="logo-container" [title]="'app.title' | translate">
    <span class="logo-title">{{ 'app.title' | translate }}</span>
  </div>

  <span class="spacer"></span>

  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <div class="menu-language-container" (click)="$event.stopPropagation()">
      <div class="menu-section-title">
        {{ 'app.header.language.label' | translate }}
      </div>

      <select class="native-language-select" [formControl]="languageControl">
        @for (lang of languages; track lang.code) {
          <option [value]="lang.code">
            {{ lang.labelKey | translate }}
          </option>
        }
      </select>
    </div>

    <mat-divider class="menu-divider"></mat-divider>

    <button mat-menu-item (click)="goToHome()">
      <mat-icon>home</mat-icon>
      {{ 'app.header.home' | translate }}
    </button>

    <button mat-menu-item (click)="goToDashboard()">
      <mat-icon>insights</mat-icon>
      {{ 'app.header.dashboard' | translate }}
    </button>

    <mat-divider class="menu-divider"></mat-divider>

    <button mat-menu-item (click)="goToProfile()">
      <mat-icon>person</mat-icon>
      {{ 'app.header.profile' | translate }}
    </button>

    <button mat-menu-item (click)="logOut()">
      <mat-icon>logout</mat-icon>
      {{ 'app.header.logout' | translate }}
    </button>
  </mat-menu>
</mat-toolbar>

<div class="ukraine-flag-stripe" aria-hidden="true">
  <span class="ukraine-flag-stripe__blue"></span>
  <span class="ukraine-flag-stripe__yellow"></span>
</div>
